
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Howl } from 'howler';
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";

import {
  DeepLoop
} from '@/common/deepLoop/deepLoop'

import { RoleVoiceManageAPI } from "@/common/api/userManage/roleVoiceManage";
import { CommonApi } from "@/common/api/common";

import {
  getCommonList,
  shareConfirmOptions
} from '@/common/config'

// import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(RoleVoiceManageAPI);

import {
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";


// 分类:1普通话2方言
const roleVoiceCategory2Ch: string[] = ['', '普通话', '方言']

// 状态：1上架，2下架
const roleVoiceStatus2Ch: string[] = ['', '上架', '下架']


const defaultForms: any = {
  name: '',
  remark: '',
  category: 1, // 分类:1普通话 2方言
  voice_file_id: '',
  voice_file_url: '',
  sort: '',
  status: 1, // 状态：1上架，2下架
}

const roleVoiceDialogTitle2ch: any = {
  "new-role-voice": "新增角色语音",
  "edit-role-voice": "编辑角色语音",
};

@Component({
  filters: {
    showRoleVoiceCategoryName(category: number) {
      return roleVoiceCategory2Ch[category] || ''
    },

    showRoleVoiceStatusName(status: number) {
      return roleVoiceStatus2Ch[status] || ''
    }
  }
})
export default class RoleVoiceManage extends Vue {
  private utilInstance: any;
  private roleVoiceManageApi: any;

  private commonApi: any;

  private deepLoopUtil: any = {};


  constructor() {
    super();
    this.roleVoiceManageApi = new RoleVoiceManageAPI();

    this.commonApi = new CommonApi();

    this.deepLoopUtil = new DeepLoop();

    this.utilInstance = new Util();

    this.forms = {
      ...DeepLoop.deepClone(defaultForms)
    }

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  private roleVoiceCategoryList: any[] = [
    ...getCommonList(roleVoiceCategory2Ch, 1)
  ]

  private form: any = {
    name: "", // 名称
  };

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.roleVoiceManageApi.getRoleVoiceTableList(
      this.getRoleVoiceTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getRoleVoiceTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userName, // 用户昵称
      name, // 名称
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {};

    if (name) {
      outerParams.name = name;
    }
    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(outerParams.created_start_time && outerParams.created_end_time)
    // ) {
    //   this.$message.error("请选择时段导出数据");
    //   return null;
    // }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  private audioPlayer: any

  private onPlayAudio(item: any) {
    const {
      voice_file_url
    } = item || {}

    if (!voice_file_url) {
      this.$message.error('缺失语音链接')
      return
    }

    if (this.audioPlayer) {
      this.stopAndClearAuidoPlayer()
    }

    const sound = this.audioPlayer = new Howl({
      src: [item.voice_file_url]
    });

    sound.once('load', function(){
      sound.play();
    });
  }

  private stopAndClearAuidoPlayer() {
    this.audioPlayer.stop()

    this.audioPlayer = null
  }

  private upFileloading: boolean = false

  private upfileList: any[] = []

  private handleCustomFileUploadFile(file: any) {
    this.upFileloading = true;
    this.commonApi.getOssLimitIntNameFile(
      file instanceof File ? file : file.raw,
      (res: any) => {
        console.log(res, "res 文件上传成功");

        const { data } = res;

        const { data: uploadFileObj } = data || {};

        const { item: uploadFile } = uploadFileObj || {};

        const { id, url } = uploadFile || {};

        this.$set(this.forms, 'voice_file_id', id)
        this.$set(this.forms, 'voice_file_url', url)

        this.upfileList.push({
          id,
          url
        })

        console.log(this.forms, 'forms')

        this.upFileloading = false;
      },
      (err: any) => {
        const {
          errMsg = ''
        } = err || {}

        this.$message.error(errMsg || "文件上传失败");

        this.upFileloading = false;
      },
    );
  }

  private onFileRemove(file: any) {
    const upfileList = this.upfileList

    const existFileIndex = upfileList.findIndex((eachFile) => eachFile.id == file.id)

    if (existFileIndex > -1) {
      this.upfileList.splice(existFileIndex, 1)

      this.$set(this.forms, 'voice_file_id', '')
      this.$set(this.forms, 'voice_file_url', '')
    }
  }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  // 查看音效包管理
  private onGoRoleVoiceEffectManage(userItem: any): void {
    console.log(userItem, "userItem");

    const { id: roleVoiceId } = userItem || {};

    if (roleVoiceId) {
      this.$router.push({
        path: "/soundEffectPack",
        query: {
          roleVoiceId,
        },
      });
    }
  }

  private onDeleteRoleVoiceManage(userItem: any) {
    const {
      id = ''
    } = userItem || {}

    this.$confirm("确认删除该角色语音吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.roleVoiceManageApi.delRoleVoice(
          {
            voice_id: id,
          },
          () => {
            this.$message.success("删除成功");
            this.getTable();
          }
      );
    });
  }


  // 角色语音管理
  private changeRoleVoiceLoading: boolean = false

  private addOrUpdateRoleVoiceManageTitle: string = "角色语音";

  private roleVoiceDialogMode: string = "";

  private currentRoleVoiceManageItem: any = null;

  private dialogFormVisible: boolean = false

  private forms: any = {}
  private onWakeRoleVoiceDialog(mode: string) {
    this.roleVoiceDialogMode = mode;
    this.addOrUpdateRoleVoiceManageTitle =
      roleVoiceDialogTitle2ch[mode] || "角色语音";

    this.initRoleVoiceManageForm(mode);

    this.dialogFormVisible = true;
  }

   private async initRoleVoiceManageForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    this.upfileList = []


    if (mode == "edit-role-voice") {
      const currentRoleVoiceManageItem = this.currentRoleVoiceManageItem;

      const {
        id,
        name = '',
        remark = '',
        category,
        voice_file_id = '',
        voice_file_url = '',
        sort,
        status,
      } = currentRoleVoiceManageItem || {};

      Object.assign(forms, {
        name,
        remark,
        category,
        sort,
        voice_file_id,
        voice_file_url,
        status
      });


      this.upfileList = [{
        id: voice_file_id,
        url: voice_file_url
      }]


      forms.id = id;
    }

    console.log(forms, "forms");

    this.forms = forms;
  }

  private onWakeEditRoleVoiceManageDialog(roleVoiceItem: any) {
    this.currentRoleVoiceManageItem = roleVoiceItem;

    this.onWakeRoleVoiceDialog("edit-role-voice");
  }

  private getRoleVoiceParams(mode: string) {
    const forms = this.forms

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const params: any = {}

    const {
      id,
      // voice_file_id,
    } = forms

    const keys = ["name", "remark", "category", "voice_file_id", "sort", "status"];

    const key2EndKey: any = {
      name: "name",
      remark: "remark",
      category: "category",
      voice_file_id: "voice_file_id",
      sort: "sort",
      status: "status"
    };

    const key2ErrMsg: any = {
      name: "名称不能为空",
      remark: "备注不能为空",
      category: "分类不能为空",
      voice_file_id: "角色语音包不能为空",
      sort: "排序不能为空",
      status: "状态不能为空"
    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }

    
    if (mode == "edit-role-voice") {
      params.voice_id = id;
    }

    

    return params
  }

  private onConfirmRoleVoice() {
    const roleVoiceDialogMode = this.roleVoiceDialogMode;

    const params = this.getRoleVoiceParams(roleVoiceDialogMode)

    if (typeof params != 'object') return

    this.changeRoleVoiceLoading = true
    switch (roleVoiceDialogMode) {
      case "new-role-voice":
        this.roleVoiceManageApi.addRoleVoice(
          params,
          () => {
            this.getTable();
            this.dialogFormVisible = false;
            this.changeRoleVoiceLoading = false;
          },
          () => {
            this.changeRoleVoiceLoading = false;
          }
        );
        break;
      case "edit-role-voice":
        this.roleVoiceManageApi.editRoleVoice(
          params,
          () => {
            this.getTable();
            this.dialogFormVisible = false;
            this.changeRoleVoiceLoading = false;
          },
          () => {
            this.changeRoleVoiceLoading = false;
          }
        );
        break;
    }

   
  }

  private destroyed() {
    this.stopAndClearAuidoPlayer()
  }
  private deactivated() {
    this.stopAndClearAuidoPlayer()
  }
 

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   id: "用户ID",
  //   user_name: "用户昵称",
  //   phone: "用户手机号",
  //   gender_name: "性别",
  //   invite_code: "邀请码",
  //   birthday: "生日",
  //   user_level_name: "会员等级",
  //   created_at: "注册时间",
  //   account_status_name: "账户状态",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "id",
  //   "user_name",
  //   "phone",
  //   "gender_name",
  //   "invite_code",
  //   "birthday",
  //   "user_level_name",
  //   "created_at",
  //   "account_status_name",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getRoleVoiceTableListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.roleVoiceManageApi.exportExcelUserList(
  //     params,
  //     (res: any) => {
  //       const { created_start_time, created_end_time } = params || {};

  //       const filename = `用户列表 ${created_start_time}到${created_end_time}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { gender, type, status } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             // if (!forbidTime) {
  //             newItem.gender_name = this.transferGender2ch[gender];

  //             newItem.user_level_name = this.transferUserLevel2ch[type];

  //             newItem.account_status_name =
  //               this.transferUserAccountStatus2ch[status];
  //             // }

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
